import { css } from 'styled-components';
import tw from 'twin.macro';

export const CommonStyles = css`
  ${tw`relative py-1.5 px-6 font-normal text-sm text-gray-700 w-full flex flex-row items-center cursor-pointer focus:outline-none`}

  &[data-highlighted] {
    ${tw`bg-gray-300 overflow-hidden`}
  }

  &[data-disabled] {
    ${tw`text-gray-400 cursor-not-allowed`}

    & svg {
      ${tw`text-gray-400`}
    }
  }

  & svg {
    ${tw`w-4 h-4 mr-2 fill-current`}
  }
`;

export const PortalCSS = css`
  ${tw`py-2 rounded shadow-lg bg-white flex flex-col items-start border border-gray-300`}
`;
